import { name } from "./block.json";

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block) {
  const buttons: NodeListOf<HTMLAnchorElement> = document.querySelectorAll(
    ".category-container a",
  );

  buttons.forEach(function (button) {
    button.addEventListener("click", function (event: MouseEvent) {
      // Remove active class from all buttons
      buttons.forEach(function (btn) {
        btn.classList.remove("active");
      });

      // Add active class to the clicked button
      (event.target as HTMLAnchorElement).classList.add("active");
    });
  });
}
